export { default } from "./VideoEmbed";
